// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organizations-page .actions {
  margin-bottom: 20px;
}
@media (min-width: 767px) {
  .organizations-page .actions .action {
    flex: 0;
    min-width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/main/admin/settings/organizations/index.less"],"names":[],"mappings":"AAAA;EAEI,mBAAA;AAAJ;AACI;EAAA;IAEI,OAAA;IACA,gBAAA;EACN;AACF","sourcesContent":[".organizations-page {\n  .actions {\n    margin-bottom: 20px;\n    @media (min-width: 767px) {\n      .action {\n        flex: 0;\n        min-width: 200px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
